(function () {
  const MOBILE_MAX = 992;

  let stepsSwiper = null;

  function initOrDestroy() {
    const el = document.querySelector("#shipping-delivery-steps");
    if (!el) return;

    const shouldBeSwiper = window.innerWidth <= MOBILE_MAX;

    if (typeof window.Swiper === "undefined") return;

    if (shouldBeSwiper && !stepsSwiper) {
      stepsSwiper = new Swiper(el, {
        slidesPerView: "auto",
        spaceBetween: 28,
        freeMode: true,
        watchOverflow: true,
        grabCursor: true,
        centeredSlides: false,
        pagination: false,
        navigation: false,
      });
    }

    if (!shouldBeSwiper && stepsSwiper) {
      stepsSwiper.destroy(true, true);
      stepsSwiper = null;

      el.querySelector(".swiper-wrapper")?.removeAttribute("style");
      el.querySelectorAll(".swiper-slide").forEach((s) =>
        s.removeAttribute("style"),
      );
    }
  }

  document.addEventListener("DOMContentLoaded", initOrDestroy);
  window.addEventListener("resize", initOrDestroy);
})();
